import axios from "axios";
import CustomSelect from "../../components/CustomSelect";
import CustomSearchInput from "../../components/CustomSearchInput";

export let registerAndProposeModal = {
    element: document.querySelector('.modal#registerAndPropose'),
    form: {
        element: document.querySelector('.modal#registerAndPropose form'),
        init() {
            new CustomSelect(this.element.projectDirectionId, {
                panel: {
                    floating: false,
                    class: 'index-dropdown__head modal-form__input input',
                    placeholderClass: 'index-dropdown__placeholder',
                    labelClass: 'index-dropdown__select',
                },
            })
            new CustomSearchInput(this.element.cityId, {
                url: '/api/cities/paginate'
            })
            new CustomSearchInput(this.element.streetId, {
                url: '/api/streets/paginate',
                data: () => {
                    return {
                        cityId: this.element.cityId.value,
                    }
                }
            })
            new CustomSearchInput(this.element.houseId, {
                url: '/api/houses/paginate',
                data: () => {
                    return {
                        cityId: this.element.cityId.value,
                        streetId: this.element.streetId.value,
                    }
                }
            })


            this.element.addEventListener('submit', event => {
                event.preventDefault()
                this.send()
                return false
            })
        },
        send() {
            axios.post('/api/auth/sign-up-propose', new FormData(this.element))
                .then(result => {
                    let response = result.data
                    if (response.success) {
                        this.notify.success('Заявка отправлена!', 1000)
                            .then(() => {
                                this.reset()
                                registerAndProposeModal.close()
                                window.location.reload()
                            })
                    } else if (response.message) {
                        this.notify.error(response.message)
                    }
                })
                .catch(error => {
                    let message = '', errors = error.response?.data?.errors
                    for (let key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            message += errors[key].map(error => `<p>${error}</p>`).join('')
                        }
                    }
                    message && this.notify.error(message)
                })
        },
        notify: {
            element: document.querySelector('.modal#registerAndPropose .js-message-block'),
            set(message) {
                this.element.innerHTML = message
            },
            error(message, clearAfter = null) {
                this.set(message)
                this.element.classList.add('has-error')

                if (clearAfter) {
                    return this.clear(clearAfter)
                }
            },
            success(message, clearAfter = null) {
                this.set(message)
                this.element.classList.add('has-success')

                if (clearAfter) {
                    return this.clear(clearAfter)
                }
            },
            clear(after = null) {
                if (after) {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            this.set('')
                            resolve()
                        }, after)
                    })
                }
                this.set('')
            }
        },
        reset() {
            this.element.dispatchEvent(new Event('reset'))
            this.notify.clear()
        },
    },
    init() {
        this.form.init()


        document.querySelectorAll('[href="#registerAndPropose"]').forEach(button => button.addEventListener('click', () => {
          $.magnificPopup.close()

          let form = button.closest('form')
          if (form) {
              this.form.element.projectDirectionId.value = form.projectDirectionId.value ?? ''
              this.form.element.projectDirectionId.CustomSelect.chooseFromSelect()
              this.form.element.text.value = form.text.value ?? ''
          }
          if (button.dataset.projectDirectionId) {
              this.form.element.projectDirectionId.value = button.dataset.projectDirectionId
              this.form.element.projectDirectionId.CustomSelect.chooseFromSelect()
          }

          setTimeout(() => this.open(), 300)
        }))
    },
    open() {
        $.magnificPopup.open({
            items: {
                src: $(this.element),
            },
            type: 'inline',
            fixedContentPos: false,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: 'mfp-with-zoom',
            callbacks: {
                close: () => {
                    this.close()
                    return false
                }
            }
        });
    },
    close() {
        this.form.reset()
        $.magnificPopup.close();
    },
}


